module.exports = __webpack_public_path__ + "img/TDE_Hammer.6b4b857e.png";